import AnimateOnScroll from "../AnimateOnScroll";
import sparebankOst from "@/assets/sparebanken-ost.png";
import sparebank1Bv from "@/assets/sparebank1-bv.svg";

const sponsors = [
  { name: "Sparebanken Øst", logo: sparebankOst },
  { name: "Sparebank1 BV stiftelsen", logo: sparebank1Bv },
];

const SponsorLogosSection = () => {
  return (
    <section className="px-6 py-16">
      <div className="mx-auto max-w-4xl">
        <AnimateOnScroll>
          <div className="flex flex-wrap items-center justify-center gap-12 md:gap-16">
            {sponsors.map((sponsor) => (
              <div key={sponsor.name} className="flex flex-col items-center gap-3">
                <img
                  src={sponsor.logo}
                  alt={sponsor.name}
                  className="h-20 w-auto object-contain md:h-24"
                  loading="lazy"
                  width={96}
                  height={96}
                />
              </div>
            ))}
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
};

export default SponsorLogosSection;
